import { largeTabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.backgroundLightest};
  padding: 10px 30px;

  @media (${largeTabletMax}) {
    padding: 10px 15px;
  }
`;

export const Content = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 1200px;
  align-items: center;
`;
